/*
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-07-22 10:59:31
 * @LastEditTime: 2026-07-14 12:19:26
 * @Description: 通用脚本方法
 * @Param:
 * @FilePath: \ShiMoMobile\src\assets\js\currencyFun\index.js
 */

const currencyFun = Object.create(null);

/**
 * @Description             按租户获取时间节点
 * @param val               原数
 * @param nub               截取小数位数
 */
currencyFun.truncatedDecimal = async (val, nub) => {
    let newVal = '';
    const row = val.toString().split('.');
    if (row.length > 1 && row[1].length > nub) {
        newVal = `${row[0]}.${row[1].slice(0, nub)}`;
    } else {
        newVal = val;
    }
    return newVal;
};

/**
 * 格式化时间
 * @param date  日期对象
 * @param fmt   格式化格式
 * @returns {*} 时间字符串 yyyy-MM-dd HH:mm:ss
 */
currencyFun.timeFormat = (date = new Date(), fmt) => {
    const o = {
        'M+': date.getMonth() + 1, // 月份
        'L+': date.getMonth() === 0 ? '12' : date.getMonth(), // 上个月
        'Q+': date.getMonth() - 1, // 上上个月
        'd+': date.getDate(), // 日
        'H+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
    };
    if (fmt === 'yyyy-LL' && o['L+'] === '12') { // 处理年份 获取上一个月的年份是去年12月份
        if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() - 1 + '').substr(4 - RegExp.$1.length)); }
    } else if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return fmt;
};

// 获取当月时间
currencyFun.getMonthData = () => {
    const returnTime = {};
    const nowDate = new Date();
    const fullYear = nowDate.getFullYear();
    const month = nowDate.getMonth() + 1;
    const endOfMonth = new Date(fullYear, month, 0).getDate();
    returnTime.startDate = currencyFun.timeFormat(new Date(nowDate.setDate(1)), 'yyyy-MM-dd');
    returnTime.endDate = currencyFun.timeFormat(new Date(nowDate.setDate(endOfMonth)), 'yyyy-MM-dd');
    return returnTime;
};

// 获取当月至今时间
currencyFun.getMonthToPresentData = () => {
    const returnTime = {};
    const nowDate = new Date();
    returnTime.startDate = currencyFun.timeFormat(new Date(nowDate.setDate(1)), 'yyyy-MM-dd');
    returnTime.endDate = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd');
    return returnTime;
};

// 获取当前年一月一号至今天
currencyFun.currentYearToPresent = () => {
    const start = new Date();
    start.setMonth(0);
    start.setDate(1);
    const s = currencyFun.timeFormat(start, 'yyyy-MM-dd');
    const e = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd');
    return [s, e];
};

// 本日
currencyFun.nowDay = () => {
    const start = new Date();
    const end = new Date();
    end.setTime(end.getTime() + 3600 * 1000 * 24);
    const s = currencyFun.timeFormat(start, 'yyyy-MM-dd');
    const e = currencyFun.timeFormat(end, 'yyyy-MM-dd');
    return [s, e];
};
// 上一日
currencyFun.prevDay = () => {
    const start = new Date();
    const end = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24);
    const s = currencyFun.timeFormat(start, 'yyyy-MM-dd');
    const e = currencyFun.timeFormat(end, 'yyyy-MM-dd');
    return [s, e];
};
// 上周
currencyFun.prevWeek = () => {
    const start = new Date();
    const end = new Date();
    start.setDate(start.getDate() - start.getDay() - 6);
    end.setDate(end.getDate() - end.getDay() + 1);
    const s = currencyFun.timeFormat(start, 'yyyy-MM-dd');
    const e = currencyFun.timeFormat(end, 'yyyy-MM-dd');
    return [s, e];
};
// 本周
currencyFun.nowWeek = () => {
    const start = new Date();
    const end = new Date();
    start.setDate(start.getDate() - start.getDay() + 1);
    end.setDate(end.getDate() - end.getDay() + 8);
    const s = currencyFun.timeFormat(start, 'yyyy-MM-dd');
    const e = currencyFun.timeFormat(end, 'yyyy-MM-dd');
    return [s, e];
};
// 上一月
currencyFun.prevMonth = () => {
    const start = new Date();
    const end = new Date();
    start.setMonth(start.getMonth() - 1);
    const s = currencyFun.timeFormat(start, 'yyyy-MM-01');
    const e = currencyFun.timeFormat(end, 'yyyy-MM-01');
    return [s, e];
};
// 本月
currencyFun.nowMonth = () => {
    const start = new Date();
    const end = new Date();
    end.setMonth(start.getMonth() + 1);
    const s = currencyFun.timeFormat(start, 'yyyy-MM-01');
    const e = currencyFun.timeFormat(end, 'yyyy-MM-01');
    return [s, e];
};
// 最近一月
currencyFun.recentMonth = () => {
    const start = new Date();
    const end = new Date();
    start.setMonth(start.getMonth() - 1);
    end.setDate(end.getDate() + 1);
    const s = currencyFun.timeFormat(start, 'yyyy-MM-dd');
    const e = currencyFun.timeFormat(end, 'yyyy-MM-dd');
    return [s, e];
};

// 上一月【统计时间上月第一天00:00:00 至 上月最后一天23:59:59】
currencyFun.prevMonthFull = ({ fmt = 'yyyy-MM-dd HH:mm:ss' } = {}) => {
    const start = new Date();
    const end = new Date();
    start.setMonth(start.getMonth() - 1);
    start.setDate(1);
    end.setDate(0);
    const s = currencyFun.timeFormat(start, fmt);
    const e = currencyFun.timeFormat(end, fmt);
    return [s, e];
};

// 财务月【统计时间：上月24号00:00:00 至 本月24号00:00:00】
currencyFun.nowMonth_customize = ({ fmt = 'yyyy-MM-dd HH:mm:ss', startDate = 24, endDate = 24 } = {}) => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const start = new Date(year, month - 1, startDate);
    const end = new Date(year, month, endDate);
    const s = currencyFun.timeFormat(start, fmt);
    const e = currencyFun.timeFormat(end, fmt);
    return [s, e];
};

/**
 * @Description             数组分组
 * @param arr               原数组
 * @param param             分组依据字段
 */
currencyFun.groupByType = (arr, param) => {
    const map = {};
    const dest = [];
    for (let i = 0; i < arr.length; i++) {
        const ai = arr[i];
        if (ai[param] && !map[ai[param]]) {
            dest.push({
                key: ai[param],
                val: [ai],
            });
            map[ai[param]] = ai;
        } else {
            for (let j = 0; j < dest.length; j++) {
                const dj = dest[j];
                if (dj.key === ai[param]) {
                    dj.val.push(ai);
                    break;
                }
            }
        }
    }
    return dest;
};

/**
 * 保留两位小数四舍五入
 * @param nub 原数字
 * @param digit 保留小数位数
 * @returns {*} 处理后数字
 */
currencyFun.decimalDistance = (nub, digit = 2) => {
    const multiple = Math.pow(10, digit);
    return Math.round(nub * multiple) / multiple;
};

export default currencyFun;
